import { Suspense } from "react"
import { Link } from "react-router-dom-7"

import { useNewNotifications } from "~/domain/notification"
import { useUserInfo } from "~/domain/user-session"
import { ErrorBoundary, MaterialIcon, PopupHint } from "~/shared/ui"
import { ErrorMessageFallback } from "~/shared/ui/components/errors/ErrorMessageFallback"

import { Counter } from "./Counter"
import { actionButtonSize, iconStyle } from "./style"
import { useMediaQuery } from "react-responsive"
import { breakPoints } from "~/shared/ui/constants"

function NotificationCount() {
	const newNotifications = useNewNotifications()
	const notificationCount = newNotifications.length

	return notificationCount > 0 ? <Counter count={notificationCount} /> : null
}

export function NotificationButton() {
	const userInfo = useUserInfo()

	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })

	if (!userInfo) return null

	return (
		<PopupHint text="Уведомления" position="bottom">
			<div className="relative">
				<Link to="/main/notifications" style={{textDecoration: 'none'}}>
					<MaterialIcon
						style={{
							flex: "0 1 auto",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							fontSize: isSmallDevice ? "1.6rem" : "2.2rem",
							...actionButtonSize,
							...iconStyle }}
						name="notifications"
					/>
				</Link>
				<ErrorBoundary fallback={<ErrorMessageFallback />}>
					<Suspense>
						<NotificationCount />
					</Suspense>
				</ErrorBoundary>
			</div>
		</PopupHint>
	)
}
